import React, { Component } from "react";
import FeaturedItems from "./FeaturedItems";
import europe from "./Europe";
import asia from "./Asia";
import america from "./America";
import { Link } from "react-router-dom";

export default class FrontPageItems extends Component {
  render() {
    const featuredEurope = shuffle(europe)
      .slice(0, 3)
      .map(item => <FeaturedItems key={item.id} item={item} />);
    const featuredAsia = shuffle(asia)
      .slice(0, 3)
      .map(item => <FeaturedItems key={item.id} item={item} />);
    const featuredAmerica = shuffle(america)
      .slice(0, 3)
      .map(item => <FeaturedItems key={item.id} item={item} />);
    function shuffle(array) {
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    }

    return (
      <div className="container">
        <h1 className="text-center mt-3">Featured items</h1>
        <div className="row mt-3">
          <div className="card col-12">
            <Link to="/america" className='d-flex justify-content-md-center justify-content-lg-start full-card-div america-link'>
              <div className="card-title d-flex align-items-center">
                <i className="fas fa-globe-americas mx-2 mt-2" />{" "}
                <h3 className="mx-2 mt-3">America</h3>
              </div>
              <div className='slider america'/>
            </Link>
            <div className="row justify-content-md-center">{featuredAmerica}</div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="card col-12">
            <Link to="/asia" className='d-flex justify-content-md-center justify-content-lg-start full-card-div asia-link'>
              <div className="card-title d-flex align-items-center">
                <i className="fas fa-globe-asia mx-2 mt-2" />{" "}
                <h3 className="mx-2 mt-3">Asia</h3>
              </div>
              <div className='slider asia'/>
            </Link>
            <div className="row justify-content-md-center">{featuredAsia}</div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="card col-12">
            <Link to="/europe" className='d-flex justify-content-md-center justify-content-lg-start full-card-div europe-link'>
              <div className="card-title d-flex align-items-center">
                <i className="fas fa-globe-europe mx-2 mt-2" />{" "}
                <h3 className="mx-2 mt-3">Europe</h3>
              </div>
              <div className='slider europe'/>
            </Link>
            <div className="row justify-content-md-center">{featuredEurope}</div>
          </div>
        </div>
      </div>
    );
  }
}
